import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

export default function PrivateRoute({ children }){
  const user = useSelector(s => s?.auth?.user);
  const authLoaded = useSelector(s => s?.auth?.loaded);
  const companyInfoComplete = useSelector(s => s?.company?.complete);
  // A support handoff opens the app with a fresh Redux store. Wait for /api/user
  // before redirecting, otherwise the valid short-lived cookie is discarded.
  if (!authLoaded) return null;
  if (!user) return <Navigate to="/login" replace />;
  // if (!companyInfoComplete) return <Navigate to="/myinfo" replace />;
  return children;
}
